module.exports = __webpack_public_path__ + "static/sectors-graphic-1450eba03adce9995741c004dbb3cb43.gif";